export const MyRegExps = {
  ZipCode: /[0-9]{4} ?[a-zA-Z]{2}/,
  EmailAdress: /[a-zA-Z0-9-]{1,}@([a-zA-Z.])?[a-zA-Z]{1,}.[a-zA-Z]{1,4}/,
}
